
import axios from 'axios';

// Hardcoded production API URL
 const baseURL = 'https://safrjal.com/api/';
 //const baseURL = 'http://localhost:3001/';

const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Auth API calls
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
  getProfile: () => api.get('/auth/profile'),
  updateProfile: (data) => api.put('/auth/profile', data),
  changePassword: (data) => api.put('/auth/password', data),
};

// API Keys API calls
export const apiKeysAPI = {
  list: () => api.get('/api-keys/list'),
  create: (data) => api.post('/api-keys/generate', data),
  revoke: (id) => api.post(`/api-keys/revoke/${id}`),
  getKey: (id) => api.get(`/api-keys/${id}`),
};

// Usage API calls
export const usageAPI = {
  getStats: () => api.get('/dashboard/stats'),
  getLogs: (params) => api.get('/dashboard/logs', { params }),
  getUsageByDay: (days = 7) => api.get('/dashboard/usage-by-day', { params: { days } }),
};

// Admin API calls
export const adminAPI = {
  getUsers: (params) => api.get('/admin/users', { params }),
  getUser: (id) => api.get(`/admin/users/${id}`),
  createUser: (data) => api.post('/admin/users', data),
  updateUser: (id, data) => api.put(`/admin/users/${id}`, data),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
  addBalance: (data) => api.post('/admin/add-balance', data),
  getPlans: () => api.get('/admin/plans'),
  getPlan: (id) => api.get(`/admin/plans/${id}`),
  createPlan: (data) => api.post('/admin/plans', data),
  updatePlan: (id, data) => api.put(`/admin/plans/${id}`, data),
  deletePlan: (id) => api.delete(`/admin/plans/${id}`),
  getStats: () => api.get('/admin/stats'),
  // Account Management APIs
  getAccounts: () => api.get('/admin/accounts'),
  registerAccount: (data) => api.post('/admin/accounts/register', data),
  confirmPhone: (sessionId, data) => api.post(`/admin/accounts/${sessionId}/confirm-phone`, data),
  activateAccount: (sessionId) => api.put(`/admin/accounts/${sessionId}/activate`),
  deactivateAccount: (sessionId) => api.put(`/admin/accounts/${sessionId}/deactivate`),
  deleteAccount: (sessionId) => api.delete(`/admin/accounts/${sessionId}`),
  reconnectAccount: (sessionId) => api.post(`/admin/accounts/${sessionId}/reconnect`),
  getQrCode: (sessionId) => api.get(`/api/qr/${sessionId}`),
};

// Plans API calls
export const plansAPI = {
  list: () => api.get('/plans/public/plans'),
  getPricing: () => api.get('/plans/public/pricing'),
  getCurrentPlan: () => api.get('/plans/current'),
  upgradePlan: (planId) => api.post('/plans/upgrade', { plan_id: planId }),
};

export { baseURL };
export default api;
 